import React, { Component } from 'react'
import { translate } from '../Services/translation'
import { get } from '../Services/http'
import { isNullOrWhiteSpace } from '../Services/strings'
import SearchableDropdown from '../Components/SearchableDropdown'
import LoadingOverlay from '../Components/LoadingOverlay'

const rootRoute = '/api/vehicleFinder'

class VehicleFinder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            manufacturers: null,
            selectedManufacturer: null,
            models: null,
            selectedModel: null,
            variants: null,
            selectedVariant: null,
            error: null,
        }
        this.elementRef = React.createRef();
        this.handleManufacturerChange = this.handleManufacturerChange.bind(this)
        this.handleModelChange = this.handleModelChange.bind(this)
        this.handleVariantChange = this.handleVariantChange.bind(this)
    }

    componentDidUpdate(prevProps, prevState) {
        const trimmedRegNo = this.props.regNo.replaceAll(' ', '')
        if(this.props.regNo !== prevProps.regNo && trimmedRegNo.length === 6)
            this.props.getVehicleDataByRegNo()
    }

    componentDidMount() {
        get(rootRoute + '/GetManufacturers')
            .then((response) => response.json())
            .then((data) => {
                if(this.elementRef.current != null)
                    this.setState((previousState) => ({
                        ...previousState,
                        manufacturers: data,
                    }))
            })
            .catch((ex) => {
                if(this.elementRef.current != null)
                    this.setState((previousState) => ({
                        ...previousState,
                        error: translate('vehiclefinder.generalerrortext'),
                    }))
            })
    }

    handleManufacturerChange(e, selectedOption) {
        this.setState(
            (previousState) => ({
                ...previousState,
                models: null,
                selectedModel: null,
                error: null,
            }),
            () => {
                if (!isNullOrWhiteSpace(selectedOption.value)) {
                    get(rootRoute + '/GetModels/' + selectedOption.value)
                        .then((response) => response.json())
                        .then((data) => {
                            this.setState((previousState) => ({
                                ...previousState,
                                selectedManufacturer: selectedOption.value,
                                models: data,
                            }))
                        })
                        .catch((ex) => {
                            this.setState((previousState) => ({
                                ...previousState,
                                error: translate(
                                    'vehiclefinder.generalerrortext'
                                ),
                            }))
                        })
                } else {
                    this.setState((previousState) => ({
                        ...previousState,
                        selectedManufacturer: null,
                    }))
                }
            }
        )
    }

    handleModelChange(e, selectedOption) {
        this.setState(
            (previousState) => ({
                ...previousState,
                variants: null,
                selectedVariant: null,
                error: null,
            }),
            () => {
                if (!isNullOrWhiteSpace(selectedOption.value)) {
                    get(rootRoute + '/GetVariants/' + selectedOption.value)
                        .then((response) => response.json())
                        .then((data) => {
                            this.setState((previousState) => ({
                                ...previousState,
                                selectedModel: selectedOption.value,
                                variants: data,
                                selectedVariant: null,
                            }))
                        })
                        .catch((ex) => {
                            this.setState((previousState) => ({
                                ...previousState,
                                error: translate(
                                    'vehiclefinder.generalerrortext'
                                ),
                            }))
                        })
                } else {
                    this.setState((previousState) => ({
                        ...previousState,
                        selectedModel: null,
                        variants: null,
                    }))
                }
            }
        )
    }

    handleVariantChange(e, selectedOption) {
        if (!isNullOrWhiteSpace(selectedOption.value)) {
            this.props.getVehicleDataByVehicleSelector(
                selectedOption.value
            )
        } else {
            this.setState((previousState) => ({
                ...previousState,
                selectedVariant: null,
            }))
        }
    }

    render() {
        return (
            <section ref={this.elementRef} className="tab">
                <input
                    type="radio"
                    className="tab__radio"
                    id="regnr"
                    name="tab-radio"
                    defaultChecked
                />
                <input
                    type="radio"
                    className="tab__radio"
                    id="model"
                    name="tab-radio"
                />

                <nav className="tab__header-container">
                    <label className="tab__header" htmlFor="regnr">
                        {translate('vehiclefinder.registrationnumber')}
                    </label>
                    <label className="tab__header" htmlFor="model">
                        {translate('vehiclefinder.carmodel')}
                    </label>
                </nav>

                <section className="tab__content-container">
                    <div className="tab__content">
                        <input
                            className="vehicle-finder__image-eu"
                            type="text"
                            ref={(input) => {
                                this.regNoInput = input
                            }}
                            onChange={(event) =>
                                this.props.handleRegNoInputChange(
                                    event.target.value
                                )
                            }
                            onClick={(event) =>
                                this.props.handleRegNoInputClick()
                            }
                            onKeyDown={(e) =>
                                e.key === 'Enter'
                                    ? this.props.getVehicleDataByRegNo()
                                    : null
                            }
                            placeholder={translate(
                                'vehiclefinder.registrationnumber.placeholder'
                            )}
                            maxLength="6"
                            value={this.props.regNo}
                        ></input>

                        {this.props.errors && this.props.errors['general'] && (
                            <div className="vehicle-finder__error">
                                {this.props.errors['general'][0]}
                            </div>
                        )}
                    </div>
                    <div className="tab__content">
                        {this.state.manufacturers &&
                            this.state.manufacturers.length > 0 && (
                                <SearchableDropdown
                                    {...{
                                        options: this.state.manufacturers,
                                        handleOnChange: this
                                            .handleManufacturerChange,
                                        placeholderText: translate(
                                            'vehiclefinder.manufacturerselector.placeholder'
                                        ),
                                    }}
                                />
                            )}
                        {this.state.selectedManufacturer &&
                            this.state.models &&
                            this.state.models.length > 0 && (
                                <SearchableDropdown
                                    {...{
                                        options: this.state.models,
                                        handleOnChange: this.handleModelChange,
                                        placeholderText: translate(
                                            'vehiclefinder.modelselector.placeholder'
                                        ),
                                    }}
                                />
                            )}
                        {this.state.selectedModel &&
                            this.state.variants &&
                            this.state.variants.length > 0 && (
                                <SearchableDropdown
                                    {...{
                                        options: this.state.variants,
                                        handleOnChange: this
                                            .handleVariantChange,
                                        placeholderText: translate(
                                            'vehiclefinder.variantselector.placeholder'
                                        ),
                                    }}
                                />
                            )}
                        {this.state.error && (
                            <div className="vehicle-finder__error">
                                {this.state.error}
                            </div>
                        )}
                        {this.props.errors && this.props.errors['general'] && (
                            <div className="vehicle-finder__error">
                                {this.props.errors['general'][0]}
                            </div>
                        )}
                    </div>
                </section>
                <LoadingOverlay loading={this.props.loading} />
            </section>
        )
    }
}

export default VehicleFinder
